// extracted by mini-css-extract-plugin
export default {"Description":"CaseStudy-module--Description--xeZDf","Title":"CaseStudy-module--Title--VrYkn"};